// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__pY7Ds","filesListContainer":"PosDisputesFiles_filesListContainer__2jT2B","filesButton":"PosDisputesFiles_filesButton__1zFVu"};